import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { ClienteAnaliseMercadoStatusProjetadoModule } from '../status-projetado';
import { ClienteAnaliseMercadoLancamentoModule } from '../lancamento';
import { ClienteCarteiraTipoModule } from '../../cliente-carteira/tipo';
import { ClientePipeSharedModule } from '../../pessoa/cliente/pipes';
import { ClienteCadastroModule } from '../../pessoa/cliente/cadastro';
import { ClienteSituacaoModule } from '../../pessoa/cliente/situacao';
import { ClienteTypeaheadSharedModule } from '../../pessoa/cliente/typeahead';
import { RepresentantePipeSharedModule } from '../../pessoa/representante/pipes';

import { ClienteAnaliseMercadoProjecaoProgressComponent } from './progress';
import { ClienteAnaliseMercadoProjecaoFormComponent } from './form';
import { ClienteAnaliseMercadoProjecaoFormModalComponent } from './form-modal';
import { ClienteAnaliseMercadoProjecaoPerdaModalComponent } from './perda';
import { ClienteAnaliseMercadoProjecaoClassificacaoPipelineCardComponent } from './classificacao';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoStatusProjetadoModule,
        ClienteAnaliseMercadoLancamentoModule,
        ClienteCarteiraTipoModule,
        ClientePipeSharedModule,
        ClienteCadastroModule,
        ClienteSituacaoModule,
        ClienteTypeaheadSharedModule,
        RepresentantePipeSharedModule
    ],
    declarations: [
        ClienteAnaliseMercadoProjecaoProgressComponent,
        ClienteAnaliseMercadoProjecaoFormComponent,
        ClienteAnaliseMercadoProjecaoFormModalComponent,
        ClienteAnaliseMercadoProjecaoPerdaModalComponent,
        ClienteAnaliseMercadoProjecaoClassificacaoPipelineCardComponent
    ],
    exports: [
        ClienteAnaliseMercadoProjecaoProgressComponent,
        ClienteAnaliseMercadoProjecaoFormComponent,
        ClienteAnaliseMercadoProjecaoFormModalComponent,
        ClienteAnaliseMercadoProjecaoPerdaModalComponent,
        ClienteAnaliseMercadoProjecaoClassificacaoPipelineCardComponent
    ]
})
export class ClienteAnaliseMercadoProjecaoModule { }
